import React from 'react'
import { FaEdit } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';

export default function AnnouncementListAction(props) {

    const { editModal, modalLoading, editForm, departmentUpdate } = props;

    const edit_announcement = () => {
        modalLoading(true)
        editModal(true)
        editForm(props?.data)
        departmentUpdate(props?.data?.department_data)
        modalLoading(false)
    }

    return (
        <div>
            <FaEdit size={20} className='edit ms-3'
                onClick={() => edit_announcement()}
                data-tooltip-id="edit"
                data-tooltip-content="Edit Announcement!"
                data-tooltip-place="bottom"
            />
            <Tooltip id="edit" style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
        </div>
    )
}
